const isObject = (value) => {
  return value && typeof value === 'object' && !Array.isArray(value);
};

export const deepMerge = (target, source) => {
  if (!source) {
    return target;
  }
  const result = Array.isArray(target) ? [...target] : { ...target };
  Object.keys(source).forEach((key) => {
    const targetValue = result[key];
    const sourceValue = source[key];
    if (isObject(targetValue) && isObject(sourceValue)) {
      result[key] = deepMerge(targetValue, sourceValue);
    } else {
      result[key] = sourceValue;
    }
  });
  return result;
};

const flattenContentInternal = (value, path, result) => {
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    if (path) {
      result[path] = String(value);
    }
    return;
  }
  if (Array.isArray(value)) {
    value.forEach((item, index) => {
      const nextPath = path ? `${path}[${index}]` : `[${index}]`;
      flattenContentInternal(item, nextPath, result);
    });
    return;
  }
  if (isObject(value)) {
    Object.keys(value).forEach((key) => {
      const nextPath = path ? `${path}.${key}` : key;
      flattenContentInternal(value[key], nextPath, result);
    });
  }
};

const parsePathSegments = (path) => {
  const segments = [];
  if (!path) {
    return segments;
  }
  const parts = path.split('.');
  parts.forEach((part) => {
    const pattern = /([^\[\]]+)|\[(\d+)\]/g;
    let match = pattern.exec(part);
    while (match) {
      if (match[1] !== undefined) {
        segments.push(match[1]);
      } else if (match[2] !== undefined) {
        segments.push(Number(match[2]));
      }
      match = pattern.exec(part);
    }
  });
  return segments;
};

const setValueAtPath = (target, path, value) => {
  const segments = parsePathSegments(path);
  if (!segments.length) {
    return;
  }
  let current = target;
  for (let index = 0; index < segments.length; index += 1) {
    const key = segments[index];
    const isLast = index === segments.length - 1;
    if (isLast) {
      current[key] = value;
    } else {
      const nextKey = segments[index + 1];
      const shouldBeArray = typeof nextKey === 'number';
      if (current[key] === undefined || current[key] === null) {
        current[key] = shouldBeArray ? [] : {};
      }
      current = current[key];
    }
  }
};

export const flattenContent = (content) => {
  const result = {};
  flattenContentInternal(content, '', result);
  return result;
};

export const buildContentFromFields = (fields) => {
  const root = {};
  if (!fields) {
    return root;
  }
  Object.keys(fields).forEach((path) => {
    const value = fields[path];
    setValueAtPath(root, path, value);
  });
  return root;
};
